export const SET_PRESCRIPTIONS_FILTERS = "SET_PRESCRIPTIONS_FILTERS";
export const RESET_PRESCRIPTIONS_FILTERS = "RESET_PRESCRIPTIONS_FILTERS";

export const setPrescriptionsFilters = (payload) => ({ type: SET_PRESCRIPTIONS_FILTERS, payload });
export const resetPrescriptionsFilters = () => ({ type: RESET_PRESCRIPTIONS_FILTERS });
